import DetailsTab from './DetailsTab'

export default DetailsTab
